// Chỉ ytrinh là full admin. ecotech@thachhoang.com là BOD (đọc hết qua isBOD), không phải admin.
export const ADMIN_EMAILS = ['ytrinh@eco-tech.vn'];

export function isAdminEmail(email: string | null | undefined): boolean {
  return ADMIN_EMAILS.includes(email ?? '');
}
